var path = '/opt/build/repo/src/static/svg/student.svg';
var html = "e42479a3fc518b1c004f0a0b4d81972e.svg";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;